import { render, staticRenderFns } from "./CartDetailDialog.vue?vue&type=template&id=096e4953"
import script from "./CartDetailDialog.vue?vue&type=script&lang=js"
export * from "./CartDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports